import { useNavigate } from '@remix-run/react'
import { Button } from '~/design-system/primitives'

export function BannterGoToExtract() {
  const navigate = useNavigate()


  return (
    <div
      className="flex flex-col items-center py-4 px-4 rounded bg-primary-socio"
    >
      <h2 className='text-xl font-bold font-oswald text-white uppercase -tracking-[-0.125rem]'>
        Consulte seu extrato
      </h2>
      <p className="text-sm  mt-4 text-white mx-auto text-center ">
        Acompanha o histórico de acúmulo e resgate do seu saldo.
      </p>
      <Button type="button" color="primary" className="w-full mt-4" onPress={() => navigate('/myaccount/extrato')}>Acessar Extrato</Button>
    </div>
  );
}
